import { render, staticRenderFns } from "./EvaluationBox.vue?vue&type=template&id=40051d3d&scoped=true&"
import script from "./EvaluationBox.vue?vue&type=script&lang=js&"
export * from "./EvaluationBox.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationBox.vue?vue&type=style&index=0&id=40051d3d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40051d3d",
  null
  
)

export default component.exports